import assert from 'assert-ts';
import type {
  DateValidation,
  PartDate,
  PartYear,
  PartYearOrDate,
} from 'schemaDefinition/types';
import {isRangeCondition} from 'schemaDefinition';
import {evaluateDateRangeCondition} from 'schemaDefinition/functions/evaluateDateRangeCondition';
import type {ValidationArgs, ValidationResult} from './types';
import {fail} from './fail';
import {validResult} from './validResult';
import {warning} from './warning';

export const validateYearOrDateValidations = (
  validations: DateValidation | DateValidation[],
  part: PartYear | PartDate | PartYearOrDate,
  args: ValidationArgs,
  aggregateResult: ValidationResult = validResult(),
): ValidationResult => {
  (Array.isArray(validations) ? validations : [validations]).forEach(
    condition => {
      assert(
        isRangeCondition(condition),
        'validateYearOrDateValidations: only range condition supported',
        condition,
      );

      if (!evaluateDateRangeCondition(condition, args)) {
        aggregateResult = (condition.level === 'warning' ? warning : fail)(
          {
            ...args,
            part,
            validation: condition,
            messageKey: condition.messageKey,
          },
          aggregateResult,
        );
      }
    },
  );

  return aggregateResult;
};
